/**
 *
 * Asynchronously loads the component for MultipleFilter
 *
 */
import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
